import {Injectable} from '@angular/core';
import {SalesPersonDTO} from '../shared/model/bench-entry.model';

@Injectable({providedIn: 'root'})
export class DateService {
  toLocalDateString(value: any): any {
    if (!value) return null;

    if (value instanceof Date) {
      return `${value.getFullYear()}-${(value.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${value.getDate().toString().padStart(2, '0')}`;
    }

    if (typeof value === 'string') {
      let date = new Date(value);
      return `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    }

    return value.format('YYYY-MM-DD');
  }

  /**
   * True when the current LOCAL calendar date lies within [from, until] inclusive.
   * Bounds are ISO YYYY-MM-DD; the compare is lexicographic, which is correct for
   * that zero-padded fixed-width format. Uses the local date (not UTC) so an
   * absence configured for "today" doesn't flip a day early/late in the evening.
   */
  isTodayInRange(from: string | null, until: string | null): boolean {
    if (!from) return false;
    const today = this.toLocalDateString(new Date());
    // An open end (until === null) means the range is still running.
    return today >= from && (!until || today <= until);
  }

  /** True when the sales member is currently absent (today within their absence range). */
  isSalesMemberAbsent(member: SalesPersonDTO): boolean {
    return this.isTodayInRange(member.absenceFrom, member.absenceUntil);
  }
}
